window.MG_SWATCH_SETS = window.MG_SWATCH_SETS || {};
(function(){
var familySet = {
  "meta": {
    "appearance": {
      "background_color": "#ffffff",
      "background_image": "",
      "background_image_style": "center",
      "border_color": "#cfcfcf",
      "border_radius_px": 6,
      "border_scope": "image_text",
      "border_size": 2,
      "gradient_angle": 42,
      "gradient_color": "#ffffff",
      "image_radius_px": 6,
      "product_image_padding": 0,
      "shadow_size": 4,
      "text_behavior": "wrap_text",
      "text_color": "#000000",
      "text_size_desktop": 16,
      "text_size_mobile": 14,
      "text_style": "normal"
    },
    "selected_appearance": {
      "background_color": "#f5f5f5",
      "background_image": "",
      "background_image_style": "center",
      "border_color": "#000000",
      "border_radius_px": 6,
      "border_scope": "image_text",
      "border_size": 2,
      "gradient_color": "#f5f5f5",
      "image_radius_px": 4,
      "product_image_padding": 0,
      "shadow_size": 8,
      "text_color": "#000000",
      "text_style": "normal",
      "text_size_mobile": 12,
      "text_size_desktop": 13
    },
    "corner_radius_px": 6
  },
  "rows": [
    {
      "custom_html": "<span hidden data-ri-glass-families></span><style>.mgps-modal:has([data-ri-glass-families]){align-items:center!important;justify-content:center!important;padding:16px!important}.mgps-modal:has([data-ri-glass-families]) .mgps-modal__dialog{width:min(820px,calc(100vw - 32px))!important;max-width:820px!important;max-height:calc(100dvh - 32px)!important;margin:0!important}.mgps-modal:has([data-ri-glass-families]) .mgps-modal__body{min-height:0!important;max-height:calc(100dvh - 110px)!important;overflow:auto!important;overscroll-behavior:contain}.mgps-row:has([data-ri-glass-families]){display:none!important}.mgps-modal:has([data-ri-glass-families]) .mgps-img-wrap{height:230px!important;aspect-ratio:auto!important}.mgps-modal:has([data-ri-glass-families]) .mgps-img-inner img{object-fit:contain!important;object-position:center!important;width:100%!important;height:100%!important;transform:none!important}.mgps-modal:has([data-ri-glass-families]) .mgps-thumb-row{justify-content:center!important}.mgps-modal:has([data-ri-glass-families]) .mgps-title{font-size:16px!important;line-height:1.25!important;white-space:normal!important;transform:none!important}.mgps-modal:has([data-ri-glass-families]) .mgps-card-bottom{padding:12px 6px!important}@media(max-width:749px){.mgps-modal:has([data-ri-glass-families]) .mgps-img-wrap{height:160px!important}.mgps-modal:has([data-ri-glass-families]) .mgps-title{font-size:14px!important}}body:has([data-ri-glass-family=\"glass\"]) .mgps-modal:has([data-ri-glass-families]) a[href*=\"/products/decoart-glass-paint-\"]{outline:2px solid #000!important;outline-offset:-2px!important}body:has([data-ri-glass-family=\"stained\"]) .mgps-modal:has([data-ri-glass-families]) a[href*=\"/products/stained-glass-paint-emerald\"]{outline:2px solid #000!important;outline-offset:-2px!important}body:has([data-ri-glass-family=\"leadings\"]) .mgps-modal:has([data-ri-glass-families]) a[href*=\"/products/stained-glass-paint-3-d-liquid-leading\"]{outline:2px solid #000!important;outline-offset:-2px!important}</style>",
      "custom_max_width_px": "0",
      "custom_template_id": "mgps-custom-glasspaint-families",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "fit_row": false,
      "heading": "",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "margin_bottom": 0,
      "margin_top": "0",
      "row_height": 0,
      "row_justify": "center",
      "subheading": "",
      "swatch_row": false,
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "find_product_handle_contains": "",
      "fit_row": true,
      "heading": "",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "margin_bottom": 0,
      "margin_top": 0,
      "more_popup_text": "More",
      "padding_between_rows": 8,
      "padding_between_rows_desktop": 10,
      "padding_between_rows_mobile": 8,
      "product_handle_contains": "",
      "random_zoom_max": "0",
      "randomize_zoom_area": false,
      "row_display_type": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type_mobile": "scale_to_fit",
      "row_height": "0",
      "row_height_desktop": "0",
      "row_height_mobile": "0",
      "row_justify": "center",
      "subheading": "",
      "swatch_image_zoom": "100",
      "swatch_row": true,
      "swatch_vertical_justify": "fit_to_height",
      "swatches": [
        {
          "alt": "DecoArt® Glass Paint",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/decoart-glass-paint-sky-blue",
            "text": "View"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 0,
          "product_id": 15461292703878,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/decoart-white-dgp01-2-oz-decoart-glass-paint-45335422206185.jpg?v=1792690299&width=400",
          "product_url": "/products/decoart-glass-paint-sky-blue",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/decoart-white-dgp01-2-oz-decoart-glass-paint-45335422206185.jpg?v=1792690299&width=400",
          "title": "Glass Paint",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Stained Glass Paint",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-emerald",
            "text": "View"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 0,
          "product_id": 15460320346246,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP06-emerald-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-emerald",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP06-emerald-2oz-bottle.png?v=1793319923&width=400",
          "title": "Stained Glass Paint",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® 3-D Liquid Leadings",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-3-d-liquid-leading?variant=67748369203334",
            "text": "View"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 0,
          "product_id": 15440228155526,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://retique.com/cdn/shop/files/exec-4d5bd936-a188-415c-95bb-54759aa92644.png?v=1793387938&width=400",
          "product_url": "/products/stained-glass-paint-3-d-liquid-leading?variant=67748369203334",
          "product_variant_id": 67748369203334,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://retique.com/cdn/shop/files/exec-4d5bd936-a188-415c-95bb-54759aa92644.png?v=1793387938&width=400",
          "title": "3-D Liquid Leadings",
          "type": "product",
          "vjust": "center"
        }
      ],
      "swatches_per_row": 3,
      "swatches_per_row_desktop": 3,
      "swatches_per_row_mobile": 3,
      "videos": [
        {
          "alt": "DecoArt® Glass Paint",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/decoart-glass-paint-sky-blue",
            "text": "View"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 0,
          "product_id": 15461292703878,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/decoart-white-dgp01-2-oz-decoart-glass-paint-45335422206185.jpg?v=1792690299&width=400",
          "product_url": "/products/decoart-glass-paint-sky-blue",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/decoart-white-dgp01-2-oz-decoart-glass-paint-45335422206185.jpg?v=1792690299&width=400",
          "title": "Glass Paint",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Stained Glass Paint",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-emerald",
            "text": "View"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 0,
          "product_id": 15460320346246,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP06-emerald-2oz-bottle.png?v=1793319923&width=400",
          "product_url": "/products/stained-glass-paint-emerald",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/DTGP06-emerald-2oz-bottle.png?v=1793319923&width=400",
          "title": "Stained Glass Paint",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® 3-D Liquid Leadings",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-3-d-liquid-leading?variant=67748369203334",
            "text": "View"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 0,
          "product_id": 15440228155526,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://retique.com/cdn/shop/files/exec-4d5bd936-a188-415c-95bb-54759aa92644.png?v=1793387938&width=400",
          "product_url": "/products/stained-glass-paint-3-d-liquid-leading?variant=67748369203334",
          "product_variant_id": 67748369203334,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://retique.com/cdn/shop/files/exec-4d5bd936-a188-415c-95bb-54759aa92644.png?v=1793387938&width=400",
          "title": "3-D Liquid Leadings",
          "type": "product",
          "vjust": "center"
        }
      ]
    },
    {
      "block_type": "mg_row",
      "find_product_handle_contains": "",
      "fit_row": true,
      "heading": "<h3>Complete sets &amp; kits</h3>",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "margin_bottom": 0,
      "margin_top": 20,
      "more_popup_text": "More",
      "padding_between_rows": 8,
      "padding_between_rows_desktop": 10,
      "padding_between_rows_mobile": 8,
      "product_handle_contains": "",
      "random_zoom_max": "0",
      "randomize_zoom_area": false,
      "row_display_type": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type_mobile": "scale_to_fit",
      "row_height": "0",
      "row_height_desktop": "0",
      "row_height_mobile": "0",
      "row_justify": "center",
      "subheading": "",
      "swatch_image_zoom": "100",
      "swatch_row": true,
      "swatch_vertical_justify": "fit_to_height",
      "swatches": [
        {
          "alt": "DecoArt Glass Paint Set with 9 opaque colors",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/glass-paint-set-primaries-9-count",
            "text": "View kit"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 0,
          "product_id": 15440227860614,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/81JHSlQkcfL._AC_SL1500_800x800.jpg?v=1792690288",
          "product_url": "/products/glass-paint-set-primaries-9-count",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/81JHSlQkcfL._AC_SL1500_800x800.jpg?v=1792690288",
          "title": "Glass Paint Set · 9 Colors",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt Stained Glass Paint Complete Set",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-complete-set",
            "text": "View kit"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 0,
          "product_id": 15440229761158,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/stained-glass-paint-set-complete-set-1_800x800.png?v=1792690322",
          "product_url": "/products/stained-glass-paint-complete-set",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/stained-glass-paint-set-complete-set-1_800x800.png?v=1792690322",
          "title": "Stained Glass Complete Set",
          "type": "product",
          "vjust": "center"
        }
      ],
      "swatches_per_row": 2,
      "swatches_per_row_desktop": 2,
      "swatches_per_row_mobile": 2,
      "videos": [
        {
          "alt": "DecoArt Glass Paint Set with 9 opaque colors",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/glass-paint-set-primaries-9-count",
            "text": "View kit"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 0,
          "product_id": 15440227860614,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/81JHSlQkcfL._AC_SL1500_800x800.jpg?v=1792690288",
          "product_url": "/products/glass-paint-set-primaries-9-count",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/81JHSlQkcfL._AC_SL1500_800x800.jpg?v=1792690288",
          "title": "Glass Paint Set · 9 Colors",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt Stained Glass Paint Complete Set",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-complete-set",
            "text": "View kit"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 0,
          "product_id": 15440229761158,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/stained-glass-paint-set-complete-set-1_800x800.png?v=1792690322",
          "product_url": "/products/stained-glass-paint-complete-set",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/stained-glass-paint-set-complete-set-1_800x800.png?v=1792690322",
          "title": "Stained Glass Complete Set",
          "type": "product",
          "vjust": "center"
        }
      ]
    }
  ]
};
var leadingSet = {
  "meta": {
    "appearance": {
      "background_color": "#ffffff",
      "background_image": "",
      "background_image_style": "center",
      "border_color": "#cfcfcf",
      "border_radius_px": 6,
      "border_scope": "image_text",
      "border_size": 2,
      "gradient_angle": 42,
      "gradient_color": "#ffffff",
      "image_radius_px": 6,
      "product_image_padding": 0,
      "shadow_size": 4,
      "text_behavior": "wrap_text",
      "text_color": "#000000",
      "text_size_desktop": 16,
      "text_size_mobile": 14,
      "text_style": "normal"
    },
    "selected_appearance": {
      "background_color": "#f5f5f5",
      "background_image": "",
      "background_image_style": "center",
      "border_color": "#000000",
      "border_radius_px": 6,
      "border_scope": "image_text",
      "border_size": 2,
      "gradient_color": "#f5f5f5",
      "image_radius_px": 4,
      "product_image_padding": 0,
      "shadow_size": 8,
      "text_color": "#000000",
      "text_style": "normal",
      "text_size_mobile": 12,
      "text_size_desktop": 13
    },
    "corner_radius_px": 6
  },
  "rows": [
    {
      "custom_html": "<span hidden data-ri-leading-colors></span><style>:is([data-mg-set=\"Colors-3DLeadings\"],[data-mg-set$=\"-leadings_colors\"],[id$=\"__leadings_colors\"]) .mgps-img-wrap{aspect-ratio:4 / 5!important;height:auto!important}:is([data-mg-set=\"Colors-3DLeadings\"],[data-mg-set$=\"-leadings_colors\"],[id$=\"__leadings_colors\"]) .mgps-img-inner img{width:100%!important;height:100%!important;object-fit:contain!important;transform:none!important}:is([data-mg-set=\"Colors-3DLeadings\"],[data-mg-set$=\"-leadings_colors\"],[id$=\"__leadings_colors\"]) .mgps-title{white-space:normal!important;line-height:1.2!important;font-size:14px!important}.mgps-row:has([data-ri-leading-colors]){display:none!important}@media(max-width:749px){:is([data-mg-set=\"Colors-3DLeadings\"],[data-mg-set$=\"-leadings_colors\"],[id$=\"__leadings_colors\"]) .mgps-title{font-size:12px!important}}</style>",
      "custom_max_width_px": "0",
      "custom_template_id": "mgps-custom-colors-3dleadings",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "fit_row": false,
      "heading": "",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "margin_bottom": 0,
      "margin_top": "0",
      "row_height": 0,
      "row_justify": "center",
      "subheading": "",
      "swatch_row": false,
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "find_product_handle_contains": "",
      "fit_row": true,
      "heading": "<h2>Choose your leading</h2>",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "margin_bottom": 0,
      "margin_top": 0,
      "more_popup_text": "More",
      "padding_between_rows": 8,
      "padding_between_rows_desktop": 10,
      "padding_between_rows_mobile": 8,
      "product_handle_contains": "",
      "random_zoom_max": "0",
      "randomize_zoom_area": false,
      "row_display_type": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type_mobile": "scale_to_fit",
      "row_height": "0",
      "row_height_desktop": "0",
      "row_height_mobile": "0",
      "row_justify": "center",
      "subheading": "",
      "swatch_image_zoom": "100",
      "swatch_row": true,
      "swatch_vertical_justify": "fit_to_height",
      "swatches": [
        {
          "alt": "DecoArt® Dark Lead",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-3-d-liquid-leading?variant=67748369203334",
            "text": "View"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 5.28,
          "product_id": 15440228155526,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://retique.com/cdn/shop/files/DTGP50-dark-lead-2oz-liquid-leading.png?v=1793387663&width=400",
          "product_url": "/products/stained-glass-paint-3-d-liquid-leading?variant=67748369203334",
          "product_variant_id": 67748369203334,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://retique.com/cdn/shop/files/DTGP50-dark-lead-2oz-liquid-leading.png?v=1793387663&width=400",
          "title": "Dark Lead",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Gold",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-3-d-liquid-leading?variant=67748369236102",
            "text": "View"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 5.28,
          "product_id": 15440228155526,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://retique.com/cdn/shop/files/DTGP51-gold-2oz-liquid-leading.png?v=1793387668&width=400",
          "product_url": "/products/stained-glass-paint-3-d-liquid-leading?variant=67748369236102",
          "product_variant_id": 67748369236102,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://retique.com/cdn/shop/files/DTGP51-gold-2oz-liquid-leading.png?v=1793387668&width=400",
          "title": "Gold",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Silver",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-3-d-liquid-leading?variant=67748369268870",
            "text": "View"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 5.28,
          "product_id": 15440228155526,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://retique.com/cdn/shop/files/DTGP53-silver-2oz-liquid-leading.png?v=1793387672&width=400",
          "product_url": "/products/stained-glass-paint-3-d-liquid-leading?variant=67748369268870",
          "product_variant_id": 67748369268870,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://retique.com/cdn/shop/files/DTGP53-silver-2oz-liquid-leading.png?v=1793387672&width=400",
          "title": "Silver",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® All 3 colors",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-3d-liquid-leadings-set-of-3",
            "text": "View"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 15.84,
          "product_id": 15461364891782,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://retique.com/cdn/shop/files/exec-4d5bd936-a188-415c-95bb-54759aa92644.png?v=1793387938&width=400",
          "product_url": "/products/stained-glass-paint-3d-liquid-leadings-set-of-3",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://retique.com/cdn/shop/files/exec-4d5bd936-a188-415c-95bb-54759aa92644.png?v=1793387938&width=400",
          "title": "All 3 colors",
          "type": "product",
          "vjust": "center"
        }
      ],
      "swatches_per_row": 4,
      "swatches_per_row_desktop": 4,
      "swatches_per_row_mobile": 4,
      "videos": [
        {
          "alt": "DecoArt® Dark Lead",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-3-d-liquid-leading?variant=67748369203334",
            "text": "View"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 5.28,
          "product_id": 15440228155526,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://retique.com/cdn/shop/files/DTGP50-dark-lead-2oz-liquid-leading.png?v=1793387663&width=400",
          "product_url": "/products/stained-glass-paint-3-d-liquid-leading?variant=67748369203334",
          "product_variant_id": 67748369203334,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://retique.com/cdn/shop/files/DTGP50-dark-lead-2oz-liquid-leading.png?v=1793387663&width=400",
          "title": "Dark Lead",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Gold",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-3-d-liquid-leading?variant=67748369236102",
            "text": "View"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 5.28,
          "product_id": 15440228155526,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://retique.com/cdn/shop/files/DTGP51-gold-2oz-liquid-leading.png?v=1793387668&width=400",
          "product_url": "/products/stained-glass-paint-3-d-liquid-leading?variant=67748369236102",
          "product_variant_id": 67748369236102,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://retique.com/cdn/shop/files/DTGP51-gold-2oz-liquid-leading.png?v=1793387668&width=400",
          "title": "Gold",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Silver",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-3-d-liquid-leading?variant=67748369268870",
            "text": "View"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 5.28,
          "product_id": 15440228155526,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://retique.com/cdn/shop/files/DTGP53-silver-2oz-liquid-leading.png?v=1793387672&width=400",
          "product_url": "/products/stained-glass-paint-3-d-liquid-leading?variant=67748369268870",
          "product_variant_id": 67748369268870,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://retique.com/cdn/shop/files/DTGP53-silver-2oz-liquid-leading.png?v=1793387672&width=400",
          "title": "Silver",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® All 3 colors",
          "available": true,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/stained-glass-paint-3d-liquid-leadings-set-of-3",
            "text": "View"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "",
          "price_num": 15.84,
          "product_id": 15461364891782,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://retique.com/cdn/shop/files/exec-4d5bd936-a188-415c-95bb-54759aa92644.png?v=1793387938&width=400",
          "product_url": "/products/stained-glass-paint-3d-liquid-leadings-set-of-3",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": false,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://retique.com/cdn/shop/files/exec-4d5bd936-a188-415c-95bb-54759aa92644.png?v=1793387938&width=400",
          "title": "All 3 colors",
          "type": "product",
          "vjust": "center"
        }
      ]
    }
  ]
};
var images=window.RI_GLASS_PAINT_IMAGES||{};
familySet.rows[1].swatches.forEach(function(card,index){var key=["glass","stained","leadings"][index];if(images[key]){card.thumbnail=images[key];card.product_image_url=images[key];}});
leadingSet.rows[1].swatches.forEach(function(card,index){var image=index===3?images.bundle:(images.leading_variants||{})[String(card.product_variant_id)];if(image){card.thumbnail=image;card.product_image_url=image;}});
familySet.rows[1].videos=familySet.rows[1].swatches.map(function(card){return Object.assign({},card);});
leadingSet.rows[1].videos=leadingSet.rows[1].swatches.map(function(card){return Object.assign({},card);});
window.MG_SWATCH_SETS["GlassPaint-Families"]=familySet;
window.MG_SWATCH_SETS["Colors-3DLeadings"]=leadingSet;
function refreshRanges(){setTimeout(function(){window.MG_SWATCH_SETS=window.MG_SWATCH_SETS||{};window.MG_SWATCH_SETS["GlassPaint-Families"]=familySet;
window.MG_SWATCH_SETS["Colors-3DLeadings"]=leadingSet;var runtime=window.__MGProductSwatchesRuntime;if(runtime&&typeof runtime.refresh==="function")document.querySelectorAll('[data-mg-set$="-glass_paint_families"],[data-mg-set$="-leadings_colors"]').forEach(function(root){runtime.refresh(root);});},0);}if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",refreshRanges,{once:true});else refreshRanges();
})();

(function(){var labels={"67748369203334":"Dark Lead","67748369236102":"Gold","67748369268870":"Silver"};function sync(event){var node=document.querySelector("[data-ri-leading-selection=single] [data-ri-leading-name]");if(!node)return;var variant=event&&event.detail&&event.detail.variant;var id=variant&&variant.id?String(variant.id):new URL(window.location.href).searchParams.get("variant");var label=labels[id];if(label&&node.textContent!==label)node.textContent=label;}function schedule(event){requestAnimationFrame(function(){sync(event);});}document.addEventListener("variant:changed",schedule);window.addEventListener("popstate",schedule);window.addEventListener("pageshow",schedule);if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",sync,{once:true});else sync();})();

// Native range roots are refreshed above; avoid redrawing unrelated color swatches.
